import { useEffect, useState } from 'react'
import textServices from 'services/text-services'
import useMediaQuery from 'hooks/use-media-query'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { CREDENCIALES_ASSETS, CREDENCIALES_STORES_ID, STORES, credencialesImage } from '../constants'

// Baked tiles (border, background and logo) at 1.5x: _0 = default, _1 = hover
const pdvTile = (key: string, hover: boolean) =>
  encodeURI(`${CREDENCIALES_ASSETS}/PDV/pdv_${key}_${hover ? 1 : 0}_1_5x.webp`)

const CAN_HOVER_QUERY = '(hover: hover) and (min-width: 1024px)'

interface TileProps {
  store: typeof STORES[number]
  canHover: boolean
}

const StoreTile = ({ store, canHover }: TileProps) => {
  const [hovered, setHovered] = useState(false)

  return (
    <a
      className={`credenciales__stores-tile credenciales__stores-tile--${store.key}`}
      href={store.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={store.name}
      onMouseEnter={() => canHover && setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() =>
        dlTrackEvent('user_interaction', { action: 'click', element: `pdv :: ${store.key}`, section: 'credenciales' })
      }
    >
      <img src={pdvTile(store.key, hovered)} alt="" draggable={false} />
    </a>
  )
}

// Points of sale (Figma desktop 5631:1618/1619/1640, mobile 5867:4100/4101/
// 4103): one row of three tiles on desktop, two columns on mobile with the
// last tile centered on its own row.
const StoresSection = () => {
  const isDesktop = useMediaQuery('(min-width: 768px)')
  const canHover = useMediaQuery(CAN_HOVER_QUERY)

  // Preload the hover art so the swap is instant
  useEffect(() => {
    if (!canHover) return
    STORES.forEach((store) => {
      const image = new Image()
      image.src = pdvTile(store.key, true)
    })
  }, [canHover])

  return (
    <section id={CREDENCIALES_STORES_ID} className="credenciales__stores">
      <img
        className="credenciales__stores-bottle"
        src={credencialesImage(isDesktop ? 'DESKTOP' : 'MOBILE', isDesktop ? 'img_botella_desk_2_2x' : 'img_botella_mob_2_2x')}
        alt=""
        aria-hidden="true"
        loading="lazy"
      />
      <img
        className="credenciales__stores-can"
        src={credencialesImage(isDesktop ? 'DESKTOP' : 'MOBILE', isDesktop ? 'img_lata_desk_2x' : 'img_lata_mob_2x')}
        alt=""
        aria-hidden="true"
        loading="lazy"
      />
      <h2 className="credenciales__stores-title">
        {textServices.findByText('credenciales/stores/title', '¿Dónde la consigo?')}
      </h2>
      <p className="credenciales__stores-text">
        {textServices.findByText(
          'credenciales/stores/text',
          'Cualquiera de nuestras presentaciones están disponibles a través de los siguientes medios:'
        )}
      </p>
      <div className="credenciales__stores-grid">
        {STORES.map((store) => (
          <StoreTile key={store.key} store={store} canHover={canHover} />
        ))}
      </div>
    </section>
  )
}

export default StoresSection
